/** Live map toolbar controls — shared layout sizes and timings. */

export const LIVE_MAP_POLL_PROGRESS_TICK_MS = 250;

export const LIVE_MAP_POLL_PROGRESS_STANDALONE_RING_SIZE = 19;
export const LIVE_MAP_POLL_PROGRESS_STANDALONE_RING_THICKNESS = 3;

export const LIVE_MAP_POLL_PROGRESS_ICON_RING_SIZE = 26;
export const LIVE_MAP_POLL_PROGRESS_ICON_RING_THICKNESS = 2.5;
